
<div class="app" :class="appClasses">
  <router-view />
  <loader />
</div>
